import ProductEditService from '../../services/ProductEditService';
import productEditUseCase from './productEditUseCase';

const productEditFactory = productEditUseCase({
  ProductEditService: ProductEditService(),
});

export default productEditFactory;
